import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { FormContainer } from './Components/SubsidyCalculationFormContainer';

import 'ts-polyfill/lib/es2015-collection';
import 'ts-polyfill/lib/es2015-core';
import 'ts-polyfill/lib/es2015-promise';

import 'url-polyfill/url-polyfill';

import 'whatwg-fetch';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const rootElement = document.getElementById('subsidy-calculation-form') as HTMLElement;
const centrelinkApiUrl = rootElement.dataset.centrelinkApiUrl || "";
const childcareCentreApiUrl = rootElement.dataset.childcareCentreApiUrl || "";
const estimateCompleteUrl = rootElement.dataset.estimateCompleteUrl || "/";
const customerDetailsUrl = rootElement.dataset.customerDetailsUrl || "";

// These two colours correspond to those used by react-md in SubsidyCalculationForm.scss
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ec1977"
    },
    secondary: {
      main: "#ec1977"
    }
  },
  typography: {
    useNextVariants: true
  }
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <FormContainer centrelinkApiUrl={centrelinkApiUrl} childcareCentreApiUrl={childcareCentreApiUrl} estimateCompleteUrl={estimateCompleteUrl} customerDetailsUrl={customerDetailsUrl} />
  </MuiThemeProvider>,
  rootElement
);
